import React, { useEffect, useState } from "react";
import { StyleSheet, View, Image, ScrollView, Alert } from "react-native";

import questions from "../api/questions";
import storage from "../auth/storage";
import ActivityIndicator from "../components/ActivityIndicator";
import AppButton from "../components/AppButton";
import AppText from "../components/AppText";
import { StdAlert } from "../components/CustomAlert";
import EntryButton from "../components/EntryButton";
import Screen from "../components/Screen";
import colors from "../config/colors";
import useApi from "../hooks/useApi";

function MigrateScreen({ navigation }) {
  const [entrySelected, setEntrySelected] = useState();
  const questionsApi = useApi(questions.getQuestions);
  const [myQuestions, setQuestions] = useState([]);

  const onNextPress = () => {
    const newData = {};
    if (!entrySelected)
      return StdAlert("", "Please select the migration type.");
    // return Alert.alert("", "Please select the migration type.");
    let type = entrySelected;
    if (entrySelected === "an Intern" || entrySelected === "a Student") {
      type = "a Student/an Intern";
    }
    newData["type"] = type;
    let index = myQuestions.apptype.findIndex(
      (x) => x.apptype_name === entrySelected
    );
    // console.log(index, entrySelected);
    newData["questions"] = myQuestions.apptype[index];
    navigation.navigate("Details", newData);
    // if (type == "an Investor") {
    //   navigation.navigate("Business", newData);
    // } else {
    //   navigation.navigate("Qualification", newData);
    // }
  };

  // const {data: myQuestions, error, loading, request: loadQuestions} = useApi(
  //   questions.getQuestions,
  // );

  useEffect(() => {
    // loadQuestions();
    async function loadQues() {
      const token = await storage.getToken();
      console.log(token, "ksfsk");
      const result = await questionsApi.request(token);
      if (result.data.apptype) {
        console.log("ksmdls", result.data, "ld");
        setQuestions(result.data);
      } else {
        return StdAlert(
          "",
          result.data.response.message ||
            "Some error occured. PLease, try again."
        );
        // return Alert.alert(
        //   "",
        //   result.data.response.message ||
        //     "Some error occured. PLease, try again."
        // );
      }
    }
    loadQues();
    return () => {
      console.log("This will be logged on unmount");
    };
  }, []);

  return (
    <Screen style={styles.container}>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: "center",
        }}
      >
        <Image
          source={require("../assets/paris_portrait.jpg")}
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
            // resizeMode: "contain",
          }}
        />
        <ActivityIndicator visible={questionsApi.loading} />
        {/* {error && (
          <>
            <AppText style={styles.centeredView}>
              Couldn't find the questions.
            </AppText>
            <AppButton
              style={styles.centeredView}
              title="Retry"
              onPress={loadJobs}
            />
          </>
        )} */}
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            backgroundColor: colors.primaryTrans,
          }}
        >
          <AppText
            color="transparent"
            textColor="white"
            style={{
              alignSelf: "center",
              fontSize: 24,
              fontWeight: "700",
              marginBottom: 20,
            }}
          >
            I want to migrate as
          </AppText>
          {myQuestions &&
            myQuestions.apptype?.map((type) => {
              return (
                <EntryButton
                  title={type.apptype_name}
                  key={type.apptype_name}
                  entrySelected={entrySelected}
                  onPress={() => setEntrySelected(type.apptype_name)}
                />
              );
            })}

          {/* <EntryButton
          title="a Professional"
          entrySelected={entrySelected}
          onPress={() => setEntrySelected("a Professional")}
        />
        <EntryButton
          title="an Investor"
          entrySelected={entrySelected}
          onPress={() => setEntrySelected("an Investor")}
        />
        <EntryButton
          title="a Student"
          entrySelected={entrySelected}
          onPress={() => setEntrySelected("a Student")}
        />
        <EntryButton
          title="an Intern"
          entrySelected={entrySelected}
          onPress={() => setEntrySelected("an Intern")}
        /> */}
          {/* <AppButton
          style={[styles.button]}
          title="a Professional"
          color={entrySelected === 0 ? "green" : "white"}
          textColor={entrySelected === 0 ? "white" : "black"}
          onPress={() => setEntrySelected(0)}
        /> */}
          {/* <AppButton
          style={[styles.button]}
          title="an Investor"
          color={entrySelected === 1 ? "green" : "white"}
          textColor={entrySelected === 1 ? "white" : "black"}
          onPress={() => setEntrySelected(1)}
        /> */}
          {/* <AppButton
          style={[styles.button]}
          title="a Student"
          color={entrySelected === 2 ? "green" : "white"}
          textColor={entrySelected === 2 ? "white" : "black"}
          onPress={() => setEntrySelected(2)}
        /> */}
          {/* <AppButton
          style={[styles.button]}
          title="an Intern"
          color={entrySelected === 3 ? "green" : "white"}
          textColor={entrySelected === 3 ? "white" : "black"}
          onPress={() => setEntrySelected(3)}
        /> */}
          <AppButton
            style={{ alignSelf: "center", marginTop: 20 }}
            color="yellow"
            textColor="black"
            title="Next"
            onPress={onNextPress}
          />
        </View>
      </ScrollView>
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {},
  button: {
    margin: 20,
    alignSelf: "center",
    width: "80%",
  },
});

export default MigrateScreen;
